const META_ID = "momento-search-robots";

/** Ask search engines to skip this hostname, or clear that request. */
export function applyHostnameSearchVisibility(hideFromSearch: boolean): void {
  if (typeof document === "undefined") return;
  const existing = document.getElementById(META_ID);
  if (!hideFromSearch) {
    existing?.remove();
    return;
  }
  const meta = existing instanceof HTMLMetaElement
    ? existing
    : document.createElement("meta");
  meta.id = META_ID;
  meta.setAttribute("name", "robots");
  meta.setAttribute("content", "noindex, nofollow");
  if (!existing) document.head.appendChild(meta);
}
